module.exports = __webpack_public_path__ + "static/media/hippo.7a00ee39.gif";